module.exports = __webpack_public_path__ + "static/_/src/config/PsMusicConfig/musics/cd1//Track_9_Look_.mp3";